import { format, parseISO } from "date-fns"
import { Logger } from "common/api.service"
import DateTimeHelper from "common/datetime-helper"
/**
 * 複合キーでのソートを行うためのヘルパー関数
 * @param a 
 * @param b 
 * @param key 
 * @param direction 
 * @param nullsFirst 
 */
const defaultSortFunc = function (a, b, key, direction = 1, nullsFirst = 1) {
    if (a[key] == undefined && b[key] == undefined) return 0;
    if (a[key] == undefined) return nullsFirst * 1;
    if (b[key] == undefined) return nullsFirst * -1;
    if (a[key] > b[key]) return direction * 1;
    if (a[key] < b[key]) return direction * -1;
    return 0;
}
const sortFunc = function <T = any>(data: T[], keys: string[]) {
    const _data = data.slice();
    _data.sort((a, b) => {
        let order = 0;
        //keys.some(key => {
        //    order = defaultSortFunc(a, b, key);
        //    return !!order;
        //});
        for (const key of keys) {
            order = defaultSortFunc(a, b, key);
            if (order != 0) {
                return order
            }
        }
        return order;
    });
    return _data;
}
const copy = function <T = any>(arr: T[]): T[] {
    return arr.slice();
}
const copyDeep = function <T = any>(arr: T): T {
    return JSON.parse(JSON.stringify(arr))
}
/**
 * オブジェクトをディープコピーします。Date型はDate型のままにします。
 * @param object 
 */
const clone = function <T>(object: T): T {
    const stringifyReplacer = function (this: any, key, value) {

        // 日付のtoJSONにはDate.prototype.toJSONが使用されるが、これはタイムゾーンを考慮してくれない
        // toJSONを上書きする方法もあるようだがprototype汚染はしたくない
        // のでdate-fnsをつかう
        if (this[key] instanceof Date && !DateTimeHelper.isInvalidDate(this[key])) {
            return format(this[key], "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
        }
        return value
    }

    const parseReplacer = function (key, value) {

        //parseは日付型の文字列をDateにparseしてくれない！
        //自分でstringifyしたんだから責任持ってParseしてほしい……
        if (key.endsWith("Date") && typeof value == "string") {
            try {
                return parseISO(value)
            } catch (e) {
                Logger.logDebug(`[ArrayHelper.clone] '${key}: ${value}'を日付型に変換することはできませんでした。`)
                return value
            }
        }
        return value
    }
    return JSON.parse(JSON.stringify(object, stringifyReplacer), parseReplacer);
}
const remove = function <T = any>(arr: T[], comparer: (item: T) => boolean): void {
    let index = -1;
    for (let i = 0; i < arr.length; i++) {
        if (comparer(arr[i])) {
            index = i;
            break;
        }
    }
    if (index == -1) {
        return;
    }
    arr.splice(index, 1);
}

/**配列内でcomparerに合致する要素の、一つ前の要素を返します。
 * 合致する要素がない場合、要素が最初の要素の場合はnullを返します。
 * @param arr
 * @param comparer
 */
function getPrevItem<T = any>(arr: T[], comparer: (item: T) => boolean): T | null {
    const index = arr.findIndex(comparer)
    if (index == -1 || index == 0) {
        return null
    }

    return arr[index - 1]
}

/**配列内でcomparerに合致する要素の、一つ後の要素を返します。
 * 合致する要素がない場合、要素が最後の要素の場合はnullを返します。
 * @param arr 
 * @param comparer
 */
function getNextItem<T = any>(arr: T[], comparer: (item: T) => boolean): T | null {
    const index = arr.findIndex(comparer)
    if (index == -1 || index == arr.length - 1) {
        return null
    }

    return arr[index + 1]
}

/**
 * string | string[] の引数をもらい、string[] を返します。
 * @param value string | string[]
 * @returns string[]
 */
function getStringArrayFromStringOrStringArray(value: string | string[]): string[] {
    if (typeof value === 'string' || value instanceof String) {
        value = [value as string]
    }
    return value;
}

export default {
    defaultSortFunc,
    sortFunc,
    copy,
    copyDeep,
    remove,
    getPrevItem,
    getNextItem,
    clone,
    getStringArrayFromStringOrStringArray
}
